import { Component, Input } from '@angular/core';

@Component({
    selector: 'fe-promotion-terms',
    templateUrl: './promotion-terms.component.html',
    styleUrls: ['./promotion-terms.component.scss'],
})
export class PromotionTermsComponent {
    @Input() terms?: string | null;
}
